module.exports = __webpack_public_path__ + "static/media/cucunver.b4c6a182.png";